import { ReactElement, useMemo } from 'react'
import { Box } from '@mui/material'
import { useGuidToElement } from '@editorHooks'
import FormBase from './components/FormBase'

interface Props {
  anchorGuid: string
  wallGuid: string
  initialData: CornerConnectionProposal

  fetchWithInterval: () => void
  isLoadingWithInterval: boolean

  disableAccept?: boolean

  onAccept: (formula: string, val: string, rawFormula: string, maxForce: number) => void
}

const CornerConnectionProposalForm = ({
  anchorGuid,
  wallGuid,

  initialData,

  fetchWithInterval,
  isLoadingWithInterval,

  disableAccept = false,
  onAccept,
}: Props): ReactElement => {
  const guidToElement = useGuidToElement()
  const wallLength = useMemo(() => {
    const wall = guidToElement[wallGuid] as ShapeObject
    const wallStart = wall.shape.points[0]
    const wallEnd = wall.shape.points[1]
    return wallStart.distanceTo(wallEnd)
  }, [wallGuid, guidToElement])

  const collectionLeft = useMemo(() => {
    if (!initialData.left_interval) return

    return wallLength * (initialData.left_interval.upper - initialData.left_interval.lower)
  }, [wallLength, initialData])

  const collectionRight = useMemo(() => {
    if (!initialData.right_interval) return

    return wallLength * (initialData.right_interval.upper - initialData.right_interval.lower)
  }, [wallLength, initialData])

  return (
    <Box component="div" m={2}>
      <FormBase
        onFetchNew={fetchWithInterval}
        wallGuid={wallGuid}
        anchorGuid={anchorGuid}
        collectionLeft={collectionLeft}
        collectionRight={collectionRight}
        wallLength={wallLength}
        supportPosition={initialData.support_position}
        isLoadingNew={isLoadingWithInterval}
        onAccept={onAccept}
        resultingForce={initialData.resulting_force}
        resultingFormula={initialData.formula}
        disableAccept={disableAccept}
      />
    </Box>
  )
}

export default CornerConnectionProposalForm
